export default {
  methods: {
    formatMoney (amount, region = null) {
      if (typeof amount !== 'number') {
        return amount
      }

      const locale = 'uk'
      let currency = 'UAH'

      if (region) {
        switch (region) {
          case 'Global':
            currency = 'USD'
            break
          case 'EU':
            currency = 'EUR'
            break
          case 'MD':
            currency = 'MDL'
        }
      }

      return amount.toLocaleString(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
      })
    },

    formatWithSymbol (amount, symbol) {
      if (typeof amount !== 'number') {
        return amount
      }

      return amount.toLocaleString('uk', {
        minimumFractionDigits: 0,
      }) + ' ' + symbol
    }
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/currency.js